import { I18n } from "aws-amplify";
import React, { useEffect, useState } from "react";

import "./codeInput.css";

const CodeInput = ({ onSubmit, submitButton, onWrongCodeInput }) => {
  const [numberCodeForm, setNumberCodeForm] = useState(null);
  const [numberCodeInputs, setNumberCodeInputs] = useState(null);
  const [wrongCode, setWrongCode] = useState(false);

  useEffect(() => {
    // Elements
    if (numberCodeForm !== null) {
      setNumberCodeInputs([
        ...numberCodeForm.querySelectorAll("[data-number-code-input]"),
      ]);
    } else {
      setNumberCodeForm(document.querySelector("[data-number-code-form]"));
    }
  }, [numberCodeForm]);

  useEffect(() => {
    if (numberCodeInputs !== null) {
      // Event listeners
      numberCodeForm.addEventListener("input", handleInput);
      numberCodeForm.addEventListener("keydown", handleKeyDown);
    }
  }, [numberCodeInputs]);

  // Event callbacks
  const handleInput = ({ target }) => {
    if (!target.value.length) {
      return (target.value = null);
    }

    const inputLength = target.value.length;
    let currentIndex = Number(target.dataset.numberCodeInput);

    if (inputLength > 1) {
      const inputValues = target.value.split("");

      inputValues.forEach((value, valueIndex) => {
        const nextValueIndex = currentIndex + valueIndex;

        if (nextValueIndex >= numberCodeInputs.length) {
          return;
        }

        numberCodeInputs[nextValueIndex].value = value;
      });

      currentIndex += inputValues.length - 2;
    }

    const nextIndex = currentIndex + 1;

    if (nextIndex < numberCodeInputs.length) {
      numberCodeInputs[nextIndex].focus();
    }
    const code = [...numberCodeInputs].map((input) => input.value).join("");
    if (code?.length === 6) setWrongCode(false);
  };

  const handleKeyDown = (e) => {
    const { code, target } = e;

    const currentIndex = Number(target.dataset.numberCodeInput);
    const previousIndex = currentIndex - 1;
    const nextIndex = currentIndex + 1;

    const hasPreviousIndex = previousIndex >= 0;
    const hasNextIndex = nextIndex <= numberCodeInputs.length - 1;

    switch (code) {
      case "ArrowLeft":
      case "ArrowUp":
        if (hasPreviousIndex) {
          numberCodeInputs[previousIndex].focus();
        }
        e.preventDefault();
        break;

      case "ArrowRight":
      case "ArrowDown":
        if (hasNextIndex) {
          numberCodeInputs[nextIndex].focus();
        }
        e.preventDefault();
        break;
      case "Backspace":
        if (!e.target.value.length && hasPreviousIndex) {
          numberCodeInputs[previousIndex].value = null;
          numberCodeInputs[previousIndex].focus();
        }
        break;
      default:
        break;
    }
  };

  function formSumbitHandler(e) {
    e.preventDefault();
    const code = [...numberCodeInputs].map((input) => input.value).join("");
    if (code?.length === 6) onSubmit(code);
    else {
      setWrongCode(true);
      onWrongCodeInput && onWrongCodeInput();
    }
  }

  return (
    <div>
      <form className="dm-auth-code-input-form" onSubmit={formSumbitHandler}>
        <fieldset name="number-code" data-number-code-form>
          <legend>Number Code</legend>
          <input
            autoFocus
            type="number"
            min="0"
            max="9"
            name="number-code-0"
            data-number-code-input="0"
          />
          <input
            type="number"
            min="0"
            max="9"
            name="number-code-1"
            data-number-code-input="1"
          />
          <input
            type="number"
            min="0"
            max="9"
            name="number-code-2"
            data-number-code-input="2"
          />
          <input
            type="number"
            min="0"
            max="9"
            name="number-code-3"
            data-number-code-input="3"
          />
          <input
            type="number"
            min="0"
            max="9"
            name="number-code-4"
            data-number-code-input="4"
          />
          <input
            type="number"
            min="0"
            max="9"
            name="number-code-5"
            data-number-code-input="5"
          />
        </fieldset>
        {submitButton}
      </form>
      <span
        className={`dm-auth-code-input-alert ${wrongCode ? "show-error" : ""}`}>
        {I18n.get("The code must have 6 digits")}
      </span>
    </div>
  );
};

export default CodeInput;
